import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import {
  FaCheckCircle,
  FaCar,
  FaMapMarkerAlt,
  FaUser,
  FaCreditCard,
  FaInfoCircle,
  FaHome,
  FaPrint,
  FaDownload,
  FaEnvelope,
} from "react-icons/fa";
import logo from "../images/Aombre-round-logo.png";


function Confirmation() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { bookingNumber, vehicleData, searchData, formData } =
    location.state || {};

  if (!bookingNumber || !vehicleData || !searchData || !formData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <FaInfoCircle className="text-4xl text-yellow-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Missing Booking Data
          </h2>
          <p className="text-gray-600 mb-4">
            Please start your booking process again.
          </p>
          <button
            onClick={() => navigate("/")}
            className="bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12 bg-[#edebec] ">
      <div className="max-w-6xl mx-auto px-4" id="confirmation-content">
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="text-center relative">
            <FaCheckCircle className="text-6xl text-green-500 mx-auto mb-6" />
            <h1 className="text-3xl font-bold text-gray-800 mb-4">
              Booking Confirmed!
            </h1>
            {/* Logo in the corner */}
            <img
              src={logo}
              alt="Aombre Logo"
              className="w-52 h-52 absolute top-0 right-0 opacity-30"
            />
            <p className="text-xl text-gray-600 mb-6">
              Your booking number is:{" "}
              <strong className="text-[#ca8032]">{bookingNumber}</strong>
            </p>
          </div>

          {/* Booking Details Summary */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 ">
            {/* Vehicle Details */}
            <div className="bg-gray-50 rounded-b-lg overflow-hidden shadow">
              <div className="bg-[#006039] p-4">
                <h2 className="text-xl font-semibold text-[#edebec] flex items-center">
                  <FaCar className="mr-2 text-[#ca8032]" />
                  Vehicle Details
                </h2>
              </div>

              <div className="flex flex-col md:flex-row p-6 gap-6 ">
                <div className="md:w-1/2 flex flex-col justify-start space-y-4 text-gray-700 text-sm rounded-lg ">
                  <p className="font-medium text-lg">
                    {vehicleData.Vehicle_Name}{" "}
                    <span className="font-medium text-sm">or similar</span>
                  </p>
                  <div className="space-y-2">
                    <div className="flex justify-between border-b pb-1">
                      <span className="font-medium">Class:</span>
                      <span>
                        {vehicleData.Vehicle_Sub_Type ||
                          vehicleData.Vehicle_Class ||
                          vehicleData.car_class ||
                          "N/A"}
                      </span>
                    </div>
                    {/* <div className="flex justify-between  pb-1"> */}
                    {/* <span className="font-medium">Transmission:</span>
                      <span>
                        {vehicleData.Transmission ||
                          vehicleData.transmission ||
                          "N/A"}
                      </span> */}
                    {/* </div> */}
                    <div className="flex justify-between border-b pb-1">
                      <span className="font-medium">AC:</span>
                      <span>{vehicleData.AC || vehicleData.ac || "N/A"}</span>
                    </div>
                    <div className="flex justify-between border-b pb-1">
                      <span className="font-medium">Doors:</span>
                      <span>
                        {vehicleData.Doors || vehicleData.door || "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between border-b pb-1">
                      <span className="font-medium">Seats:</span>
                      <span>
                        {vehicleData.Seats || vehicleData.seats || "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between border-b pb-1">
                      <span className="font-medium">Bags:</span>
                      <span>
                        {vehicleData.Bags || vehicleData.bags || "N/A"}
                      </span>
                    </div>
                    {/* <div className="flex justify-between">
                      <span className="font-medium">Mileage:</span>
                      <span>{vehicleData.Mileage || vehicleData.mileage || "N/A"}</span>
                    </div> */}
                  </div>
                </div>

                {vehicleData?.Vehicle_Image && (
                  <div className="md:w-1/2 flex-shrink-0">
                    <img
                      src={vehicleData.Vehicle_Image}
                      alt={vehicleData.Vehicle_Name || "Vehicle"}
                      className="w-full h-64 md:h-full object-contain rounded-md "
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Rental Period */}
            <div className="bg-gray-50 rounded-lg shadow  ">
              <div className="bg-[#006039] p-4 text-[#edebec] ">
                <h2 className="text-xl font-semibold flex items-center">
                  <FaMapMarkerAlt className="mr-2 text-[#ca8032]" />
                  Rental Details
                </h2>
              </div>
              <div className="space-y-3 p-6">
                <div>
                  <p className="font-medium">Pickup Location</p>
                  <p className="text-gray-600">
                    {searchData.pickup.pickup_location}
                  </p>
                  <p className="text-sm text-gray-500">
                    {new Date(searchData.pickup.pickup_date).toLocaleString()}
                  </p>
                </div>
                <div>
                  <p className="font-medium">Dropoff Location</p>
                  <p className="text-gray-600">
                    {searchData.dropoff.dropoff_location}
                  </p>
                  <p className="text-sm text-gray-500">
                    {new Date(searchData.dropoff.dropoff_date).toLocaleString()}
                  </p>
                </div>
                <div>
                  <p className="font-medium">Rental Duration</p>
                  <p className="text-gray-600">
                    {vehicleData.length_of_rental} days
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Customer Information */}
          <div className="bg-gray-50 rounded-lg mb-8 shadow">
            <div className="bg-[#006039] p-4 text-[#edebec] ">
              <h2 className="text-xl font-semibold flex items-center">
                <FaUser className="mr-2 text-[#ca8032]" />
                Customer Information
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
              <div>
                <p className="font-medium">Name</p>
                <p className="text-gray-600">
                  {formData.First_Name} {formData.Last_Name}
                </p>
              </div>
              <div>
                <p className="font-medium">Email</p>
                <p className="text-gray-600">{formData.Email_ID}</p>
              </div>
              <div>
                <p className="font-medium">Phone</p>
                <p className="text-gray-600">{formData.Phone_No}</p>
              </div>
              <div>
                <p className="font-medium">Date of Birth</p>
                <p className="text-gray-600">
                  {new Date(formData.DOB).toLocaleDateString()} (Age:{" "}
                  {formData.Age})
                </p>
              </div>
            </div>
          </div>

          {/* Address Information */}
          {(formData.Address ||
            formData.city ||
            formData.state ||
            formData.country ||
            formData.zip_code ||
            formData.driver_country) && (
            <div className="bg-gray-50 rounded-lg mb-8 shadow">
              <div className="bg-[#006039] p-4 text-[#edebec] ">
                <h2 className="text-xl font-semibold flex items-center">
                  <FaHome className="mr-2 text-[#ca8032]" />
                  Address Information
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
                {formData.Address && (
                  <div>
                    <p className="font-medium">Address</p>
                    <p className="text-gray-600">{formData.Address}</p>
                  </div>
                )}
                {formData.city && (
                  <div>
                    <p className="font-medium">City</p>
                    <p className="text-gray-600">{formData.city}</p>
                  </div>
                )}
                {formData.state && (
                  <div>
                    <p className="font-medium">State/Province</p>
                    <p className="text-gray-600">{formData.state}</p>
                  </div>
                )}
                {formData.country && (
                  <div>
                    <p className="font-medium">Country</p>
                    <p className="text-gray-600">{formData.country}</p>
                  </div>
                )}
                {formData.zip_code && (
                  <div>
                    <p className="font-medium">ZIP/Postal Code</p>
                    <p className="text-gray-600">{formData.zip_code}</p>
                  </div>
                )}
                {formData.driver_country && (
                  <div>
                    <p className="font-medium">Driver's License Country</p>
                    <p className="text-gray-600">{formData.driver_country}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Flight Information */}
          {(formData.flight_number || formData.flight) && (
            <div className="bg-gray-50 rounded-lg mb-8 shadow">
              <div className="bg-[#006039] p-4 text-[#edebec] ">
                <h2 className="text-xl font-semibold flex items-center">
                  <FaInfoCircle className="mr-2 text-[#ca8032]" />
                  Flight Information
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
                {formData.flight_number && (
                  <div>
                    <p className="font-medium">Flight Number</p>
                    <p className="text-gray-600">{formData.flight_number}</p>
                  </div>
                )}
                {formData.flight && (
                  <div>
                    <p className="font-medium">Airline</p>
                    <p className="text-gray-600">{formData.flight}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Optional Services */}
          {formData.selectedServices &&
            formData.selectedServices.length > 0 && (
              <div className="bg-gray-50 rounded-lg mb-8 shadow">
                <div className="bg-[#006039] p-4 text-[#edebec] ">
                  <h2 className="text-xl font-semibold ">
                    Selected Optional Services
                  </h2>
                </div>
                <div className="space-y-2 p-6">
                  {formData.selectedServices.map((service, index) => (
                    <div key={index} className="flex justify-between">
                      <span>{service.name}:</span>
                      <span>
                        {vehicleData.Currency}{" "}
                        {Number(service.total || 0).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

          {/* Payment Summary */}
          <div className="bg-gray-50 rounded-lg mb-8 shadow">
            <div className="bg-[#006039] p-4 text-[#edebec] ">
              <h2 className="text-xl font-semibold flex items-center">
                <FaCreditCard className="mr-2 text-[#ca8032]" />
                Payment Summary
              </h2>
            </div>
            <div className="space-y-2 p-6">
              <div className="flex justify-between">
                <span>Base Rate:</span>
                <span>
                  {vehicleData.Currency}{" "}
                  {Number(vehicleData.Base_Price_rate_table || 0).toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Taxes & Fees:</span>
                <span>
                  {vehicleData.Currency}{" "}
                  {Number(vehicleData.Tax_on_Car_Price_Value || 0).toFixed(2)}
                </span>
              </div>
              {Number(formData.Extras_Total_Price || 0) > 0 && (
                <div className="flex justify-between">
                  <span>Optional Services:</span>
                  <span>
                    {vehicleData.Currency}{" "}
                    {Number(formData.Extras_Total_Price || 0).toFixed(2)}
                  </span>
                </div>
              )}
              <div className="flex justify-between font-semibold text-lg border-t pt-2 mt-2 ">
                <span>
                  {vehicleData.paymentType === "POA" ? (
                    <span>Total Due:</span>
                  ) : (
                    <span>Total Amount:</span>
                  )}
                </span>
                <span className="text-[#ca8032]">
                  {vehicleData.paymentType === "POA" && (
                    <span className="mr-1 text-red-500 text-sm">
                      (To be paid on rental desk){" "}
                    </span>
                  )}
                  {vehicleData.Currency}{" "}
                  {Number(formData.Total_Price || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center gap-4 mb-6">
            {/* Print */}
            <button
              onClick={() => window.print()}
              className="flex items-center gap-2 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 no-print"
            >
              <FaPrint /> Print
            </button>

            {/* Download */}
            <button
              onClick={() => {
                const element = document.getElementById("confirmation-content");
                const opt = {
                  margin: 1,
                  filename: `Booking-${bookingNumber}.pdf`,
                  html2canvas: {
                    scale: 2,
                    backgroundColor: null,
                    logging: true,
                    useCORS: true,
                    ignoreElements: (el) => el.classList.contains("no-print"),
                  },

                  jsPDF: {
                    unit: "px",
                    format: [element.scrollWidth, element.scrollHeight],
                    orientation: "portrait",
                  },
                };
                import("html2pdf.js").then((html2pdf) => {
                  html2pdf.default().set(opt).from(element).save();
                });
              }}
              className="flex items-center gap-2 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 no-print"
            >
              <FaDownload /> Download
            </button>

            {/* Email */}
            {/* <button
              onClick={() =>
                (window.location.href = `mailto:${formData.Email_ID}?subject=Booking Confirmation&body=Your booking number is ${bookingNumber}`)
              }
              className="flex items-center gap-2 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300"
            >
              <FaEnvelope /> Email
            </button> */}
          </div>

          {/* Confirmation Message */}
          <div className="text-center mt-4">
            <p className="text-gray-600 mb-6">
              A confirmation email has been sent to {formData.Email_ID}
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Please keep this booking number for your reference:{" "}
              <strong>{bookingNumber}</strong>
            </p>

            <button
              onClick={() => navigate("/")}
              className="bg-[#ca8032] text-white px-8 py-3 rounded-lg hover:bg-[#ca8032] no-print "
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
